(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker",
                    {
                        url: "/MarketingTracker",
                        component: "marketingTracker",
                        PageTitle: "Marketing Tracker",
                        requiredPermissions: "MarketingTracker:View",
                        resolve: {
                            marketingTrackerToken: ["marketingTrackerApi", "marketingTrackerAuthService", function (marketingTrackerApi, marketingTrackerAuthService) {
                                return marketingTrackerApi.getToken().then(function (token) {
                                    marketingTrackerAuthService.setAccessToken(token);
                                    return token;
                                });
                            }]
                        },
                        redirectTo: "Home.Tools.MarketingTrackerNew"
                    });
        }
    ]);

    app
        .component("marketingTracker",
            {
                templateUrl: "App/Tools/MarketingTracker/marketingtracker-template.html",
                controller: marketingTrackerController
            });

    marketingTrackerController.$inject = ["marketingTrackerApi", "marketingTrackerAuthService", "$state"];
    function marketingTrackerController(marketingTrackerApi, marketingTrackerAuthService, $state) {
        const $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    useNewMT: localStorage.getItem("UseNewMT") === "true" ?
                        true : localStorage.getItem("UseNewMT") === "false" ?
                            false : null
                }
            });

        function _redirect() {
            if ($ctrl.ui.useNewMT) {
                $state.go('Home.Tools.MarketingTrackerNew', {}, { reload: true });
            } else {
                //$state.go('Home.Tools.MarketingTracker.Summary.Cumulative', {}, { reload: true });
            }
        }

        _redirect();
    }

})(window.angular, window.app); //jshint ignore:line